import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=f18ad718&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=f18ad718&prod&scoped=true&lang=css"
import style1 from "./Detail.vue?vue&type=style&index=1&id=f18ad718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18ad718",
  null
  
)

export default component.exports